import { cn } from "@/utils/cn";

const TableFilterButton = ({ label, count, isActive, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "px-3 py-1.5 rounded-full flex items-center gap-1 text-sm font-medium transition-colors",
        isActive ? "bg-accent text-accent-foreground" : "text-muted bg-surface border hover:text-foreground",
      )}
    >
      <span>{label}</span>
      <div
        className={cn(
          "size-5 rounded-full flex items-center justify-center bg-background",
          isActive && "!bg-accent/80",
        )}
      >
        <span className="text-xs opacity-70">{count}</span>
      </div>
    </button>
  );
};

export default TableFilterButton;